import { render, staticRenderFns } from "./list-vendas.vue?vue&type=template&id=5dbbaed3&scoped=true"
import script from "./list-vendas.vue?vue&type=script&lang=js"
export * from "./list-vendas.vue?vue&type=script&lang=js"
import style0 from "./list-vendas.vue?vue&type=style&index=0&id=5dbbaed3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dbbaed3",
  null
  
)

export default component.exports